import { Modal } from "antd";
import { Box } from "@chakra-ui/react";
import OutlineButton from "components/Button/OutlineButton";
import PrimaryButton from "components/Button/PrimaryButton";
import SelectDiaSemana from "components/Input/SelectDiaSemana";
import { useState } from "react";

interface ModalExcecaoDiaSemanaProps {
  isOpenModal: boolean;
  onClose: () => any;
  onSave: (diaSemana: number) => any;
  filterOptions?: number[];
}

export default function ModalExcecaoDiaSemana({
  isOpenModal,
  onClose,
  onSave,
  filterOptions = [],
}: ModalExcecaoDiaSemanaProps) {
  const [diaSemana, setDiaSemana] = useState<string | null>(null);

  const _onSave = () => {
    if (diaSemana) {
      onSave(Number(diaSemana));
      onClose();
      setDiaSemana(null);
    }
  };

  return (
    <Modal
      destroyOnClose
      closable={false}
      width={"600px"}
      onCancel={onClose}
      centered
      title="Escolher dia da semana"
      visible={isOpenModal}
      footer={
        <Box
          display="flex"
          gridGap={6}
          justifyContent="flex-end"
          flex={1}
          mt={4}
        >
          <OutlineButton onClick={onClose}>Cancelar</OutlineButton>

          <PrimaryButton
            disabled={!diaSemana}
            onClick={() => {
              _onSave();
            }}
          >
            Criar exceção
          </PrimaryButton>
        </Box>
      }
    >
      <Box w="50%" minW="240px" my={-4}>
        <Box mb={1}>Dia da semana</Box>
        <SelectDiaSemana
          value={diaSemana}
          onChange={setDiaSemana}
          filterOptions={filterOptions}
        />
      </Box>
    </Modal>
  );
}
